@switch (attribute?.displayType) {
  @case (displayType.Hidden) {
    <s-form-input-hidden
      [groupName]="groupName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [fieldName]="fieldName"
      [displayHint]="displayHint"
      [readonly]="readonly"
    />
  }
  @case (displayType.Boolean) {
    <s-form-input-checkbox
      [groupName]="groupName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [fieldName]="fieldName"
      [disabled]="disabled"
      [displayHint]="displayHint"
      [readonly]="readonly"
    />
  }
  @case (displayType.HTML) {
    <s-form-input-code
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [displayHint]="displayHint"
      [readonly]="readonly"
    />
  }
  @case (displayType.DateUtc) {
    <ng-container [ngTemplateOutlet]="date" />
  }
  @case (displayType.DateLocal) {
    <ng-container [ngTemplateOutlet]="date" />
  }
  @case (displayType.CalendarDateUtc) {
    <ng-container [ngTemplateOutlet]="date" />
  }
  @case (displayType.Duration) {
    <s-form-input-duration
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [displayHint]="displayHint"
      [readonly]="readonly"
      [stepMinute]="increment"
    >
      <ng-template #prefix>
        <ng-container [ngTemplateOutlet]="parentPrefix"></ng-container>
      </ng-template>
      <ng-template #suffix>
        <ng-container [ngTemplateOutlet]="parentSuffix"></ng-container>
      </ng-template>
    </s-form-input-duration>
  }
  @case (displayType.Enum) {
    <s-form-input-enum
      [groupName]="groupName"
      [fieldName]="fieldName"
      [enumObject]="enumObject"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [sort]="sort"
      [allowZero]="allowZero"
      [showClear]="showClear"
      [displayHint]="displayHint"
      [filter]="filter"
      [readonly]="readonly"
      [filter$]="filter$"
    >
      <ng-template #prefix>
        <ng-container [ngTemplateOutlet]="parentPrefix"></ng-container>
      </ng-template>
      <ng-template #suffix>
        <ng-container [ngTemplateOutlet]="parentSuffix"></ng-container>
      </ng-template>
    </s-form-input-enum>
  }
  @case (displayType.EnumArray) {
    <s-form-input-enum
      [groupName]="groupName"
      [fieldName]="fieldName"
      [enumObject]="enumObject"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [sort]="sort"
      [allowZero]="allowZero"
      [displayHint]="displayHint"
      [filter]="filter"
      [readonly]="readonly"
      [filter$]="filter$"
      [multiple]="true"
    >
      <ng-template #prefix>
        <ng-container [ngTemplateOutlet]="parentPrefix"></ng-container>
      </ng-template>
      <ng-template #suffix>
        <ng-container [ngTemplateOutlet]="parentSuffix"></ng-container>
      </ng-template>
    </s-form-input-enum>
  }
  @case (displayType.Time) {
    <s-form-input-time
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
    >
      <ng-template #prefix>
        <ng-container [ngTemplateOutlet]="parentPrefix"></ng-container>
      </ng-template>
      <ng-template #suffix>
        <ng-container [ngTemplateOutlet]="parentSuffix"></ng-container>
      </ng-template>
    </s-form-input-time>
  }
  @case (displayType.DateTimeUtc) {
    <ng-container [ngTemplateOutlet]="dateTime" />
  }
  @case (displayType.DateTimeSecUtc) {
    <ng-container [ngTemplateOutlet]="dateTime" />
  }
  @case (displayType.DateTimeLocal) {
    <ng-container [ngTemplateOutlet]="dateTime" />
  }
  @case (displayType.DateTimeSecLocal) {
    <ng-container [ngTemplateOutlet]="dateTime" />
  }
  @case (displayType.ScheduleTime) {
    <ng-container [ngTemplateOutlet]="dateTime" />
  }
  @case (displayType.Miles) {
    <ng-container [ngTemplateOutlet]="number" />
  }
  @case (displayType.Financial) {
    <ng-container [ngTemplateOutlet]="number" />
  }
  @case (displayType.Money) {
    <ng-container [ngTemplateOutlet]="number" />
  }
  @case (displayType.Rate) {
    <ng-container [ngTemplateOutlet]="number" />
  }
  @case (displayType.Number) {
    <ng-container [ngTemplateOutlet]="number" />
  }
  @default {
    <s-form-input-text
      [groupName]="groupName"
      [fieldName]="fieldName"
      [form]="form"
      [apiError]="apiError"
      [schema]="schema"
      [displayHint]="displayHint"
      [readonly]="readonly"
      [disabled]="disabled"
      [autocomplete]="autocomplete"
    >
      <ng-template #prefix>
        <ng-container [ngTemplateOutlet]="parentPrefix"></ng-container>
      </ng-template>
      <ng-template #suffix>
        <ng-container [ngTemplateOutlet]="parentSuffix"></ng-container>
      </ng-template>
    </s-form-input-text>
  }
}

<ng-template #number>
  <s-form-input-number
    [groupName]="groupName"
    [form]="form"
    [label]="label"
    [apiError]="apiError"
    [schema]="schema"
    [fieldName]="fieldName"
    [displayHint]="displayHint"
    [readonly]="readonly"
    (blurEvent)="blurEvent.emit($event)"
    [maxFractionDigits]="maxFractionDigits"
  >
    <ng-template #prefix>
      <ng-container [ngTemplateOutlet]="parentPrefix"></ng-container>
    </ng-template>
    <ng-template #suffix>
      <ng-container [ngTemplateOutlet]="parentSuffix"></ng-container>
    </ng-template>
  </s-form-input-number>
</ng-template>

<ng-template #date>
  <s-form-input-date
    [groupName]="groupName"
    [fieldName]="fieldName"
    [form]="form"
    [apiError]="apiError"
    [schema]="schema"
    [displayHint]="displayHint"
    [readonly]="readonly"
  >
    <ng-template #prefix>
      <ng-container [ngTemplateOutlet]="parentPrefix"></ng-container>
    </ng-template>
    <ng-template #suffix>
      <ng-container [ngTemplateOutlet]="parentSuffix"></ng-container>
    </ng-template>
  </s-form-input-date>
</ng-template>

<ng-template #dateTime>
  <s-form-input-date-time
    [groupName]="groupName"
    [fieldName]="fieldName"
    [form]="form"
    [apiError]="apiError"
    [schema]="schema"
    [displayHint]="displayHint"
    [showSeconds]="
      attribute?.displayType === displayType.DateTimeSecUtc || attribute?.displayType === displayType.DateTimeSecLocal
    "
    [readonly]="readonly"
    [splitInputs]="splitInputs"
  >
    <ng-template #prefix>
      <ng-container [ngTemplateOutlet]="parentPrefix"></ng-container>
    </ng-template>
    <ng-template #suffix>
      <ng-container [ngTemplateOutlet]="parentSuffix"></ng-container>
    </ng-template>
  </s-form-input-date-time>
</ng-template>
